import _ from 'lodash';
import {
    FETCH_MTOKNA_SCHEMES,
    CLEAN_MTOKNA_SCHEMES,
    CHANGE_MTOKNA_SCHEME,
    DELETE_MTOKNA_SCHEME,
} from './types';
import { request, __ } from '../functions';

export const fetchMtoknaSchemes = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/schemes', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_SCHEMES, payload: data });
    });
};

export const changeMtoknaScheme = (screen, id, data) => {
    return dispatch => request(`/mtokna/editScheme/${id}`, { data }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť schému'));
            return;
        }

        screen.showSnackbar('success', __('Schéma bola zmenená'));

        dispatch({ type: CHANGE_MTOKNA_SCHEME, payload: { id, data } });
    });
};

export const deleteMtoknaScheme = (screen, id) => {
    return dispatch => request(`/mtokna/removeScheme/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať schému'));
            return;
        }

        screen.showSnackbar('success', __('Schéma bola zmazaná'));

        dispatch({ type: DELETE_MTOKNA_SCHEME });
    });
};

export const cleanMtoknaSchemes = () => ({ type: CLEAN_MTOKNA_SCHEMES });
